import React, { FC } from 'react';
import MuiStepper, { StepperProps as MuiStepperProps } from '@mui/material/Stepper';
import { BpDesignSystem } from '../../types';
import { styled } from '../../styles';

export type StepperProps = BpDesignSystem.PropsWithChildren<MuiStepperProps>;

export const Stepper: FC<StepperProps> = ({ dataTest, ...rest }) => (
  <StyledMuiStepper color="primary" data-test={dataTest} {...rest} />
);

const StyledMuiStepper = styled(MuiStepper)`
  max-width: calc(100vw - 100px); // Keep stepper on screen.
`;
